import { Stack } from '@mui/material';
import ArticleMeta from '../../types/ArticleMeta';
import { ArticleCardLocation } from '../../utilities/gtm';
import NewsArticleCard from './NewsArticleCard';
import useGroupedNewsArticles from './useGroupedNewsArticles';
import { Fragment } from 'react';
import BrandHeading from '../Page/BrandHeading';

interface NewsArticleListProps {
  articles?: ArticleMeta[];
  location: ArticleCardLocation;
}

export default function NewsArticleList({
  articles = [],
  location,
}: Readonly<NewsArticleListProps>) {
  const groupedArticles = useGroupedNewsArticles(articles);

  return (
    <Stack
      direction='column'
      sx={{
        gap: 1,
      }}
    >
      {Object.entries(groupedArticles).map(([dateLabel, group]) => (
        <Fragment key={dateLabel}>
          <BrandHeading
            component='h3'
            variant='subtitle2'
            marginBottom={1}
            marginTop={3}
          >
            {dateLabel}
          </BrandHeading>
          {group.map((article, index) => (
            <NewsArticleCard
              key={'news-list-' + article.id}
              meta={article}
              gtmData={{ location, index }}
              heading='h4'
            />
          ))}
        </Fragment>
      ))}
    </Stack>
  );
}
